import { render, staticRenderFns } from "./CustomerStories.vue?vue&type=template&id=5af22ada&scoped=true&"
import script from "./CustomerStories.vue?vue&type=script&lang=js&"
export * from "./CustomerStories.vue?vue&type=script&lang=js&"
import style0 from "./CustomerStories.vue?vue&type=style&index=0&id=5af22ada&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af22ada",
  null
  
)

export default component.exports